/*
 * @Author: xxx xxx
 * @Date: 2023-01-31 10:25:11
 * @LastEditors: xxx xxx
 * @LastEditTime: 2023-02-28 13:59:51
 * @FilePath: \react-admin\src\divs\callback\index.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import "./index.less";
const PrizeCardAreaH5 = () => {
	return (
		<>
			<div className="box need-scroll-div">
				<div className="content" style={{ position: "relative" }}>
					<div className="content-box">
						<img src="https://dan-cn-dbc-b2b-pic.oss-cn-shanghai.aliyuncs.com/uat-b2b-pic/platform/1882057614936944640.jpg"></img>
						<img src="https://dan-cn-dbc-b2b-pic.oss-cn-shanghai.aliyuncs.com/uat-b2b-pic/platform/1882060029992022016.jpg"></img>
						<img src="https://dan-cn-dbc-b2b-pic.oss-cn-shanghai.aliyuncs.com/uat-b2b-pic/platform/1882060248817250304.jpg"></img>
						<img src="https://dan-cn-dbc-b2b-pic.oss-cn-shanghai.aliyuncs.com/uat-b2b-pic/platform/1882060330157387776.jpg"></img>
						<img src="https://dan-cn-dbc-b2b-pic.oss-cn-shanghai.aliyuncs.com/uat-b2b-pic/platform/1882060390135934976.jpg"></img>
						<img src="https://dan-cn-dbc-b2b-pic.oss-cn-shanghai.aliyuncs.com/uat-b2b-pic/platform/1882060452815613952.jpg"></img>
						<img src="https://dan-cn-dbc-b2b-pic.oss-cn-shanghai.aliyuncs.com/uat-b2b-pic/platform/1882060518594883584.jpg"></img>
						<img src="https://dan-cn-dbc-b2b-pic.oss-cn-shanghai.aliyuncs.com/uat-b2b-pic/platform/1882060579395514368.jpg"></img>
						<img src="https://dan-cn-dbc-b2b-pic.oss-cn-shanghai.aliyuncs.com/uat-b2b-pic/platform/1882060657862553600.jpg"></img>
						<img src="https://dan-cn-dbc-b2b-pic.oss-cn-shanghai.aliyuncs.com/uat-b2b-pic/platform/1882060734907723776.jpg"></img>
					</div>
				</div>
			</div>
		</>
	);
};
export default PrizeCardAreaH5;
